/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListUserActivityData } from './genericApiResponseListUserActivityData';
import type { GenericApiResponseListUserActivityMessage } from './genericApiResponseListUserActivityMessage';
import type { GenericApiResponseListUserActivityPagination } from './genericApiResponseListUserActivityPagination';
import type { GenericApiResponseListUserActivityError } from './genericApiResponseListUserActivityError';

export interface GenericApiResponseListUserActivity {
  data?: GenericApiResponseListUserActivityData;
  message?: GenericApiResponseListUserActivityMessage;
  pagination?: GenericApiResponseListUserActivityPagination;
  error?: GenericApiResponseListUserActivityError;
  statusCode?: number;
}
